import React, { useEffect, useState } from "react";
import { createAssessment, getAllStudentProfiles } from "../../API/student-mgmt";
import Upload from "../../icons/upload";
import { IKContext, IKUpload } from "imagekitio-react";
import "./manageAssesment.css";
import { ERROR_TOAST, INFO_TOAST, SUCCESS_TOAST } from "../../helpers/toasters";
import { getCoursesById } from "../../API/courses";
import { imageKitPublicKey, imageKitUrlEndpoint } from "../../helper";

interface handelFuncProps {
  handelClose: () => void;
  data?: {
    studentname: string;
    assessment_levels: string[];
    category: string;
    certification_levels: string[];
    // course_completion: boolean;
    report_card: string;
    _id: string;
  };
  selectedBatchId?: string;
  batchStudents?: Array<{ _id: string; name: string, isActive: boolean }>;
  course?: Course;
  batchName: string | null;
}

type Course = {
  _id: string;
  name: string;
  assessment_levels?: string[];
  certification_levels?: string[];
};

type Student = {
  _id: string;
  name: string;
  isActive: boolean;
  courses?: Course[];
};

const uri =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_URL
    : process.env.REACT_APP_URL;

export default function ManageAssessment(props: handelFuncProps) {
  // const [status, setStatus] = useState<boolean>(props.data?.course_completion || false);
  const [student, setStudent] = useState("");
  
  const [course, setCourse] = useState(props.course?._id || "");
  const [studentRows, setStudentRows] = useState<Student[]>(props.batchStudents || []);
  const [certificateUrl, setCertificateUrl] = useState("");
  const [reportCardUrl, setReportCardUrl] = useState("");
  const [certificateId, setCertificateId] = useState("");
  const [reportCardId, setReportCardId] = useState("");
  const [assessment, setAssessment] = useState<string[]>([]);
  const [certification, setCertification] = useState<string[]>([]);
  const [selectedAssessment, setSelectedAssessment] = useState<string>("");
  const [selectedCertification, setSelectedCertification] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [reportCardPreviewImage, setReportCardPreviewImage] = useState("");
  const [certificatePreviewImage, setCertificatePreviewImage] = useState("");
  const [assessmentName, setAssessmentName] = useState("");
  const [assessmentDate, setAssessmentDate] = useState("");
  const handleClick = () => props.handelClose();

  const onError = (e: any) => {
    ERROR_TOAST("Error while uploading your documents");
    
  };

  const onSuccess1 = (res: any) => {
    SUCCESS_TOAST("Certificate Uploaded!");
    setCertificatePreviewImage(res.url);
    setCertificateId(res.fileId);
    setCertificateUrl(res.url);
  };

  const onSuccess2 = (res: any) => {
    SUCCESS_TOAST("Report Card Uploaded!");
    setReportCardPreviewImage(res.url)
    setReportCardId(res.fileId);
    setReportCardUrl(res.url);
  };

  const removeImageReportCard = () => {
    setReportCardUrl("");
    setReportCardId("");
    setReportCardPreviewImage("");
  };

  const removeImageCertificate = () => {
    setCertificateUrl("");
    setCertificateId("");
    setCertificatePreviewImage("");
  };

  useEffect(() => {
    getFirstData();
  }, []);

  useEffect(() => {
    if (course) {
      getCoursesById(course)
        .then((data) => {
          
          const courseData = data;
          setAssessment(courseData.assessment_levels || []);
          setCertification(courseData.certification_levels || []);
          setSelectedAssessment(courseData.assessment_levels?.[0] || "");
          setSelectedCertification(courseData.certification_levels?.[0] || "");
        })
        .catch((e) => {
          ERROR_TOAST("Error while getting course levels")

        });
    }
  }, [course, props.course]);

  const getFirstData = () => {
    if (props.batchStudents && props.batchStudents.length > 0) {
      setStudentRows(props.batchStudents);
      setLoading(false);
    } else {
      getAllStudentProfiles()
        .then((data) => {
          if (!data || data.length === 0) {
            ERROR_TOAST("No student profiles found");
            setStudentRows([]);
          } else {
            setStudentRows(data);
          }
          setLoading(false);
        })
        .catch((e) => {
;
          ERROR_TOAST("Error fetching student profiles");
          setLoading(false);
        });
    }
  };

  const onSubmit = async () => {
    setLoading(true);

    if (!student) {
      setLoading(false);
      return INFO_TOAST("Please choose a student");
    }

    if (!course) {
      setLoading(false);
      return INFO_TOAST("Please choose a course for student");
    }

    if (!selectedAssessment) {
      setLoading(false);
      return INFO_TOAST("Please choose an Assessment level");
    }

    if (!selectedCertification) {
      setLoading(false);
      return INFO_TOAST("Please choose a Certificate level");
    }
    if (!assessmentName) {
      setLoading(false);
      return INFO_TOAST("Please enter assessment name");
    }

    if (!assessmentDate) {
      setLoading(false);
      return INFO_TOAST("Please select assessment date");
    }
    const data = {
      course,
      user: student,
      certificate: certificateUrl,
      reportCard: reportCardUrl,
      assessment_level: selectedAssessment,
      certificate_level: selectedCertification,
      name: assessmentName,
      date: assessmentDate,
    };

    try {
      const result = await createAssessment(data);
      if (result.response.statusCode === 200) {
        setLoading(false);
        SUCCESS_TOAST("Assessment Added Successfully");
        handleClick();
      } else {
        setLoading(false);
        ERROR_TOAST("Something went wrong, try again!");
      }
    } catch (error) {
      setLoading(false);
      ERROR_TOAST("Something went wrong, try again!");
      console.error(error);
    }
  };

  return (
    <div className="manageA">
      <div className="fullDescManageA">
        <div className="headerofma">
          <h2>Manage Assessment</h2>
          <div className="top-svg" onClick={handleClick} style={{ cursor: "pointer" }}>
            {/* SVG content unchanged */}
          </div>
        </div>
        <div className="MAssisment-border-top"></div>
        <div className="ma-body">
          {/* Assessment Details Section */}
          <div className="assessment-info-section">
            <h3 className="section-title">Assessment Details</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="cat-hello" htmlFor="assessmentName">Assessment Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={assessmentName}
                  onChange={(e) => setAssessmentName(e.target.value)}
                  placeholder="Enter assessment name"
                />
              </div>
              <div className="form-group">
                <label className="cat-hello" htmlFor="assessmentDate">Assessment Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={assessmentDate}
                  onChange={(e) => setAssessmentDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
          </div>

          {/* Student & Course Section */}
          <div className="student-course-section">
            <h3 className="section-title">Student & Course</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="cat-hello" htmlFor="student">Student Name</label>
                <select
                  name="Student_name"
                  className="form-select"
                  onChange={(e) => setStudent(e.target.value)}
                  value={student}
                >
                  <option value="">Select a student</option>
                  {studentRows.map((m) => (

                    m.isActive && (
                      <option key={m._id} value={m._id}>
                        {m.name}
                      </option>
                    )))}
                </select>
              </div>
              <div className="form-group">
                <label className="cat-hello" htmlFor="course">Batch Name</label>
                <select
                  className="form-select"
                  name="Allocate Card"
                  disabled={!!props.course}
                  onChange={(e) => setCourse(e.target.value)}
                  value={course}
                >
                  {props.batchName ? (
                    <option value={props.batchName}>{props.batchName}</option>
                  ) : (
                    <>
                      <option value="">Choose a course</option>
                      {studentRows.flatMap((z) => z.courses || []).map((m) => (
                        <option key={m._id} value={m._id}>
                          {m.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>
          </div>

          {/* Levels & Status Section */}
          <div className="levels-status-section">
            <h3 className="section-title">Levels & Status</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="cat-hello" htmlFor="certification">Certification Levels</label>
                <select
                  className="form-select"
                  name="Certification Levels"
                  onChange={(e) => setSelectedCertification(e.target.value)}
                  value={selectedCertification}
                >
                  <option value="">Select a level</option>
                  {certification.map((m, i) => (
                    <option key={i} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="cat-hello" htmlFor="assessment">Assessment Levels</label>
                <select
                  className="form-select"
                  name="Assessment Levels"
                  onChange={(e) => setSelectedAssessment(e.target.value)}
                  value={selectedAssessment}
                >
                  <option value="">Select a level</option>
                  {assessment.map((m, i) => (
                    <option key={i} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="form-group">
                <label className="cat-hello">Course Completion</label> */}
              {/* <div className="radio-child">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="choice-radio2"
                      checked={status}
                      onClick={() => setStatus(true)}
                    />
                    <span className="mx-2">Yes</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="choice-radio2"
                      checked={!status}
                      onClick={() => setStatus(false)}
                    />
                    <span className="mx-2">No</span>
                  </label>
                </div> */}
              {/* </div> */}
            </div>
          </div>

          {/* Upload Section */}
          <div className="upload-section">
            <h3 className="section-title">Upload Documents</h3>
            <div className="upload-drag-drop d-flex justify-content-around">
              <div>
                <label htmlFor="report-card">Upload Report Card</label>
                <IKContext
                  publicKey={imageKitPublicKey}
                  urlEndpoint={imageKitUrlEndpoint}
                  authenticationEndpoint={uri + `/challenge/auth`}
                >
                  {reportCardPreviewImage ? (
                    <div className="uploaded-preview-container">
                      <div className="uploaded-preview-box">
                        <img
                          src={reportCardPreviewImage}
                          alt="Uploaded preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <button className="remove-button" onClick={removeImageReportCard}>
                        Remove
                      </button>
                    </div>
                  ) : (
                    <div className="upload-area">
                      <div className="upload-icon">
                        <Upload />
                      </div>
                      <div className="upload-text">
                        <p>Upload or drag & drop files here</p>
                        <p id="upload-text-second">JPG, PNG up to 10mb</p>
                      </div>
                      <IKUpload
                        fileName="my-upload"
                        onError={onError}
                        onSuccess={onSuccess2}
                      />
                    </div>
                  )}
                </IKContext>
              </div>
              <div>
                <label htmlFor="certificate">Upload Certificate</label>
                <IKContext
                  publicKey={imageKitPublicKey}
                  urlEndpoint={imageKitUrlEndpoint}
                  authenticationEndpoint={uri + `/card/auth`}
                >
                  {certificatePreviewImage ? (
                    <div>
                      <div className="uploaded-preview-container">
                        <div className="uploaded-preview-box">
                          <img
                            src={certificatePreviewImage}
                            alt="Uploaded preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <button className="remove-button" onClick={removeImageCertificate}>
                          Remove
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="upload-area">
                      <div className="upload-icon">
                        <Upload />
                      </div>
                      <div className="upload-text">
                        <p>Upload or drag & drop files here</p>
                        <p id="upload-text-second">JPG, PNG up to 10mb</p>
                      </div>
                      <IKUpload
                        fileName="my-upload"
                        onError={onError}
                        onSuccess={onSuccess1}
                      />
                    </div>
                  )}
                </IKContext>
              </div>
            </div>
          </div>

          <div className="drag-drop-top-lineMa"></div>
          <div className="but-ManageA d-flex">
            <button className="submit-button-Ma" onClick={onSubmit} disabled={loading}>
              Submit
            </button>
            <button className="manageA-cancel-button" onClick={handleClick}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}